var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{style:({
      opacity: _vm.disabled ? 0.5 : 1.0,
      'pointer-events': _vm.disabled ? 'none' : 'initial',
    })},[(_vm.index)?_c('strong',{staticClass:"branding-field-numbering subheading mr-3",staticStyle:{"position":"relative","top":"28px"}},[_vm._v("\n      "+_vm._s(_vm.index)+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[(!_vm.noLabel)?_c('v-layout',{staticClass:"body-2 grey--text text--darken-3 mb-2",attrs:{"align-center":""}},[_vm._v("\n        "+_vm._s((_vm.label || ' ').toUpperCase())+" "),_vm._t("labelsuffix")],2):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"d-flex branding-field-box",class:{border: _vm.border},style:({
          'max-width': _vm.maxWidth,
          'min-width': _vm.minWidth,
          'max-height': _vm.maxHeight,
          'min-height': _vm.minHeight,
        })},[_vm._t("field")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BrandingField.vue?vue&type=template&id=d792be06&scoped=true&
// module id = 1910
// module chunks = 5